export default {
  importEntries: {
    pagination: {
      search: '',
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: 'created_ts',
      totalItems: 0,
      rowsPerPageItems: [10, 20, 30],
      deleted: false,
    },
    items: [],
  },
  unlinkedImportEntries: {
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 5,
      sortBy: 'created_ts',
      totalItems: 0,
      rowsPerPageItems: [5, 10, 15, 20],
    },
    items: [],
  },
  unlinkedReviews: {
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 5,
      sortBy: 'created_ts',
      totalItems: 0,
      rowsPerPageItems: [5, 10, 15, 20],
    },
    items: [],
  },
  importForm: {
    marketplaceId: null,
    sellerId: null,
    importExternalId: null,
    region: null,
    howManyReviews: null,
    howManyRatings: null,
    reviewStarSubset: 1,
    translateReviews: null,
    autoApprove: false,
    importOnlyWithImages: false,
    importAllReviews: false,
    productId: null,
    importRatings: false,
    minimumWords: null,
    automaticSync: false,
    obfuscateReviewerName: false,
  },
  importsTable: [],
};
